import Chat from "../Chat/Chat";

const ColleagueChat = () => {
    return (
        <>
            <Chat textTitle="تالار گفتگوی همکاران" />
        </>
    )
}

export default ColleagueChat;